const formatLanguageArc = languageArc => {
  const languages = languageArc.split(':');
  return `${languages[0]} -> ${languages[1]}`;
};

export const CapacityManagementUtils = {
  formatLanguageArc,
};
